import * as React from 'react'
import { LocaleStateProvider } from 'src/hooks/locale/locale'
import { MaintenanceModeProvider } from 'src/hooks/maintenanceMode'
import { MetaDataProvider } from 'src/hooks/metaData'
import { ThemeManager } from 'src/state/providers/Theme'
import Routing from './Routing'
import { SentryErrorBoundary } from './components/Error'
import StagingHttpAuthGuard from './components/StagingHttpAuthGuard'

export default function Index(): React.ReactElement | null {
  return (
    <SentryErrorBoundary>
      <StagingHttpAuthGuard>
        <ThemeManager />
        <MaintenanceModeProvider>
          <MetaDataProvider>
            <LocaleStateProvider>
              <Routing />
            </LocaleStateProvider>
          </MetaDataProvider>
        </MaintenanceModeProvider>
      </StagingHttpAuthGuard>
    </SentryErrorBoundary>
  )
}
